import Icon from '../components/Icon.vue'

Icon.register({"futbol-o":{"width":1792,"height":1792,"paths":[{"d":"M609 816l287-208 287 208-109 336h-355zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM1515 1350q149-203 149-454v-3l-102 89-240-224 63-323 134 12q-150-206-389-282l53 124-287 159-287-159 53-124q-239 76-389 282l135-12 62 323-240 224-102-89v3q0 251 149 454l30-132 326 40 139 298-116 69q117 39 240 39t240-39l-116-69 139-298 326-40z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/futbol-o.js
// module id = 1419
// module chunks = 0